/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tooltip_Auto_ReplyInputs */

const en_tooltip_auto_reply = /** @type {(inputs: Tooltip_Auto_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When enabled, the AI Concierge will automatically respond to buyer inquiries using your configured personality and the verified facts in your listing documents.`)
};

const id_tooltip_auto_reply = /** @type {(inputs: Tooltip_Auto_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat diaktifkan, Pramutamu AI akan otomatis merespons pertanyaan pembeli menggunakan kepribadian yang Anda konfigurasikan dan fakta terverifikasi dalam dokumen listing Anda.`)
};

/** @type {(inputs: Tooltip_Auto_ReplyInputs) => LocalizedString} */
const es_tooltip_auto_reply = en_tooltip_auto_reply;

/** @type {(inputs: Tooltip_Auto_ReplyInputs) => LocalizedString} */
const fr_tooltip_auto_reply = en_tooltip_auto_reply;

/** @type {(inputs: Tooltip_Auto_ReplyInputs) => LocalizedString} */
const de_tooltip_auto_reply = en_tooltip_auto_reply;

/** @type {(inputs: Tooltip_Auto_ReplyInputs) => LocalizedString} */
const ja_tooltip_auto_reply = en_tooltip_auto_reply;

/** @type {(inputs: Tooltip_Auto_ReplyInputs) => LocalizedString} */
const zh_tooltip_auto_reply = en_tooltip_auto_reply;

/** @type {(inputs: Tooltip_Auto_ReplyInputs) => LocalizedString} */
const ar_tooltip_auto_reply = en_tooltip_auto_reply;

/** @type {(inputs: Tooltip_Auto_ReplyInputs) => LocalizedString} */
const it_tooltip_auto_reply = en_tooltip_auto_reply;

/** @type {(inputs: Tooltip_Auto_ReplyInputs) => LocalizedString} */
const ru_tooltip_auto_reply = en_tooltip_auto_reply;

/** @type {(inputs: Tooltip_Auto_ReplyInputs) => LocalizedString} */
const pt_tooltip_auto_reply = en_tooltip_auto_reply;

/** @type {(inputs: Tooltip_Auto_ReplyInputs) => LocalizedString} */
const ko_tooltip_auto_reply = en_tooltip_auto_reply;

/**
* | output |
* | --- |
* | "When enabled, the AI Concierge will automatically respond to buyer inquiries using your configured personality and the verified facts in your listing documents." |
*
* @param {Tooltip_Auto_ReplyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tooltip_auto_reply = /** @type {((inputs?: Tooltip_Auto_ReplyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tooltip_Auto_ReplyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tooltip_auto_reply(inputs)
	if (locale === "es") return es_tooltip_auto_reply(inputs)
	if (locale === "fr") return fr_tooltip_auto_reply(inputs)
	if (locale === "de") return de_tooltip_auto_reply(inputs)
	if (locale === "ja") return ja_tooltip_auto_reply(inputs)
	if (locale === "zh") return zh_tooltip_auto_reply(inputs)
	if (locale === "ar") return ar_tooltip_auto_reply(inputs)
	if (locale === "id") return id_tooltip_auto_reply(inputs)
	if (locale === "it") return it_tooltip_auto_reply(inputs)
	if (locale === "ru") return ru_tooltip_auto_reply(inputs)
	if (locale === "pt") return pt_tooltip_auto_reply(inputs)
	return ko_tooltip_auto_reply(inputs)
});